import { render, staticRenderFns } from "./LandingPageSectionSubscription.vue?vue&type=template&id=4e87b28d"
import script from "./LandingPageSectionSubscription.vue?vue&type=script&lang=js"
export * from "./LandingPageSectionSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports